import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shared/components';

interface Props {
  bookingId: string;
  pending?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * Die Freigabe ist eine Aussage über die Wirklichkeit, nicht ein Knopf, der etwas repariert:
 * sie schreibt beim Kanalmanager unsere Wahrheit fest — „zu dieser Buchung gibt es hier nichts,
 * die Nächte sind frei". Stimmt das nicht, weil die Buchung real ist und nur wegen eines Fehlers
 * in Quarantäne liegt, ist die Folge eine Doppelbelegung. Deshalb muss jemand vorher beim Vendor
 * nachgesehen haben, und deshalb fragt der Dialog genau danach.
 */
export function ReleaseNightsDialog({ bookingId, pending, onClose, onConfirm }: Props) {
  return (
    <Dialog open onOpenChange={(next) => !next && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Nächte wieder freigeben?</DialogTitle>
          <DialogDescription>
            Für die Buchung {bookingId} gibt es hier keine Zeile. Die Freigabe leitet unsere
            Verfügbarkeit für diesen Zeitraum neu ab und schickt sie an den Kanalmanager.
          </DialogDescription>
        </DialogHeader>

        <DialogBody className="space-y-3">
          <p
            className="border-sealwax/40 bg-sealwax/10 text-ink rounded-md border p-3 text-sm"
            role="alert"
          >
            Prüfe vorher beim Kanalmanager, ob die Buchung dort noch aktiv ist. Ist sie das, werden
            verkaufte Nächte wieder buchbar — und der nächste Gast bucht ein belegtes Apartment.
          </p>
          <p className="text-ink-soft text-sm">
            Freigegeben wird nur, was hier wirklich frei ist: Apartments mit einer eigenen Buchung
            oder einer manuellen Kalendersperre bleiben zu.
          </p>
        </DialogBody>

        <DialogFooter>
          <Button
            type="button"
            variant="ghost"
            className="min-h-11"
            onClick={onClose}
            disabled={pending}
          >
            Abbrechen
          </Button>
          <Button
            type="button"
            variant="brand"
            className="min-h-11"
            loading={pending}
            disabled={pending}
            onClick={onConfirm}
          >
            Nächte freigeben
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
